/* Bandenmeesters — canonical mobile header/menu controller, 2026-09-10. */
(()=>{
  if(window.__bmMobileHeaderRuntime)return;
  window.__bmMobileHeaderRuntime=true;

  const GENERATION_IMAGE_CACHE_KEY='bm_generation_image_cache_v1';
  const mqDesktop=window.matchMedia('(min-width: 990px)');

  const getSelectorUrl=()=>{
    const root=window.routes?.root_url||'/';
    return `${root}${root.endsWith('/')?'':'/'}#voertuigselector`;
  };

  const vehicleLabel=(vehicle)=>{
    const api=window.BandenmeestersVehicle;
    if(api?.vehicleLabel)return api.vehicleLabel(vehicle);
    return [vehicle?.brand?.name||'',vehicle?.model?.name||'',vehicle?.generation?.name||''].filter(Boolean).join(' ');
  };

  const readImageCache=()=>{
    try{return JSON.parse(window.localStorage.getItem(GENERATION_IMAGE_CACHE_KEY)||'{}')||{}}
    catch(_){return {}}
  };

  const writeImageCache=(generationId,imageUrl)=>{
    if(!generationId||!imageUrl)return;
    try{
      const cache=readImageCache();
      cache[String(generationId)]=imageUrl;
      const keys=Object.keys(cache);
      if(keys.length>24)keys.slice(0,keys.length-24).forEach(key=>delete cache[key]);
      window.localStorage.setItem(GENERATION_IMAGE_CACHE_KEY,JSON.stringify(cache));
    }catch(_){}
  };

  const exactGenerationTarget=(vehicle)=>{
    if(vehicle?.newVehicle)return null;
    const raw=vehicle?.newVehicle ? vehicle.newVehicle.vehiclePageUrl||'' : vehicle?.generation?.url||'';
    if(!raw)return null;
    try{
      const target=new URL(raw,window.location.origin);
      const previewHost=window.location.hostname==='shopifypreview.com'
        ||window.location.hostname.endsWith('.shopifypreview.com');
      const primaryDomain=document.querySelector('[data-bm-mobile-menu-overlay]')
        ?.dataset.bmPrimaryShopDomain||'';
      let primaryOrigin='';
      try{
        if(primaryDomain&&/^[a-z\d.-]+$/i.test(primaryDomain))
          primaryOrigin=new URL('https://'+primaryDomain).origin;
      }catch(_){}
      if(target.protocol!=='https:'||target.username||target.password
        ||target.search||target.hash
        ||!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/[^/]+\/?$/.test(target.pathname)
        ||(target.origin!==window.location.origin&&!(previewHost&&target.origin===primaryOrigin)))
        return null;
      // A merchant-verified Bridge URL must load inside the same draft preview.
      return new URL(target.pathname,window.location.origin);
    }catch(_){return null}
  };

  const cachedGenerationImage=(vehicle)=>{
    const path=exactGenerationTarget(vehicle)?.pathname;
    return vehicle?.generation?.image||readImageCache()[path||String(vehicle?.generation?.id||'')]||'';
  };

  const renderMobileVehicleImage=(card,active,imageUrl='')=>{
    if(!card)return;
    const image=card.querySelector('[data-bm-mobile-vehicle-image]');
    const icon=card.querySelector('[data-bm-mobile-vehicle-icon]');
    const hasImage=Boolean(active&&imageUrl);
    card.classList.toggle('has-generation-image',hasImage);

    if(image){
      if(hasImage){
        image.src=imageUrl;
        image.alt=vehicleLabel(active)||'Gekozen auto';
        image.hidden=false;
      }else{
        image.removeAttribute('src');
        image.alt='';
        image.hidden=true;
      }
    }
    if(icon)icon.hidden=hasImage;
  };

  // Opening the menu and the Vehicle change event can run together.
  // One bounded read per exact canonical generation URL avoids duplicate Shopify GETs.
  const generationImageReadsInFlight=new Set();

  const resolveGenerationImage=async(active,card)=>{
    if(!active||!card)return;
    const target=exactGenerationTarget(active);
    if(!target)return;
    const cached=cachedGenerationImage(active);
    if(cached){renderMobileVehicleImage(card,active,cached);return}
    if(generationImageReadsInFlight.has(target.pathname))return;
    generationImageReadsInFlight.add(target.pathname);

    const exactVehicleId=String(active?.newVehicle?.vehicleId||'');
    const generationId=String(active?.generation?.id||'');
    try{
      const canonicalImage=(doc)=>{
        const source=doc.querySelector('[data-bm-canonical-generation-image]');
        if(source?.dataset.bmCanonicalGenerationImage){
          const parent=source.dataset.bmCanonicalGenerationHref||'';
          const resolvedParent=new URL(parent,window.location.origin);
          if(resolvedParent.origin===window.location.origin&&resolvedParent.pathname===target.pathname)
            return source.dataset.bmCanonicalGenerationImage;
        }
        // Legacy USED generation markup is an existing optional media owner.
        return doc.querySelector('.bm-vehicle-hero__visual img, .bm-generation-image img')?.getAttribute('src')||'';
      };
      let imageUrl='';
      if(target.pathname.replace(/\/$/,'')===window.location.pathname.replace(/\/$/,'')){
        imageUrl=canonicalImage(document);
      }
      if(!imageUrl){
        const response=await fetch(target.href,{credentials:'same-origin',headers:{'X-Requested-With':'XMLHttpRequest'}});
        if(!response.ok)return;
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        imageUrl=canonicalImage(doc);
      }
      if(!imageUrl)return;
      writeImageCache(target.pathname,imageUrl);
      const current=window.BandenmeestersVehicle?.getActive?.();
      if(String(current?.newVehicle?.vehicleId||'')===exactVehicleId
        && String(current?.generation?.id||'')===generationId
        && exactGenerationTarget(current)?.pathname===target.pathname)
        renderMobileVehicleImage(card,current,imageUrl);
    }catch(_){}
    finally{generationImageReadsInFlight.delete(target.pathname)}
  };

  const nativeExactVehicleHref = (vehicle) => {
    if (!vehicle?.vehicleId || !vehicle.vehiclePageUrl) return '';
    try {
      const current = new URL(window.location.href);
      const target = new URL(vehicle.vehiclePageUrl, current.origin);
      const canonical = target.hostname === 'bandenmeesters.be' || target.hostname === 'www.bandenmeesters.be';
      if (target.protocol !== 'https:' || target.port || target.username || target.password
        || target.search || target.hash || (!canonical && target.origin !== current.origin)
        || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?pages\/[^/]+\/[^/]+\/?$/.test(target.pathname)) return '';
      const id = current.searchParams.get('preview_theme_id') || '';
      return target.pathname + (/^\d+$/.test(id) ? '?preview_theme_id=' + id : '');
    } catch (_) { return ''; }
  };
  const draftVehicleResultsHref=()=>{
    const path='/collections/nieuwe-velgen?browse=vehicle';
    try {
      const id=new URL(window.location.href).searchParams.get('preview_theme_id');
      return /^\d+$/.test(id||'') ? path+'&preview_theme_id='+id : path;
    } catch (_) { return path; }
  };
  const syncMobileVehicleUI=()=>{
    const api=window.BandenmeestersVehicle;
    if(!api?.getActive)return false;
    const active=api.getActive()||null;

    document.querySelectorAll('[data-bm-mobile-vehicle-card]').forEach(card=>{
      const label=card.querySelector('[data-bm-mobile-vehicle-label]');
      const note=card.querySelector('[data-bm-mobile-vehicle-note]');
      const action=card.querySelector('[data-bm-mobile-vehicle-action]');
      const change=card.querySelector('[data-bm-mobile-vehicle-change]');

      card.classList.toggle('has-vehicle',Boolean(active));
      if(label)label.textContent=active?vehicleLabel(active):'Selecteer merk, model en uitvoering';
      if(note)note.textContent=active?'Bekijk velgen voor jouw geselecteerde auto.':'Toon velgen die bij jouw auto passen.';
      const resultsUrl=active?.newVehicle
        ? nativeExactVehicleHref(active.newVehicle) || (active.newVehicle.vehicleId ? draftVehicleResultsHref() : null)
        : active?.generation?.url;
      if(action){
        action.href=resultsUrl||getSelectorUrl();
        action.textContent=resultsUrl?'Bekijk velgen voor deze auto →':active?'Wijzig auto →':'Kies jouw auto →';
      }
      if(change){
        change.href=getSelectorUrl();
        change.hidden=!active||!resultsUrl;
      }

      const cached=cachedGenerationImage(active);
      renderMobileVehicleImage(card,active,cached);
      // Media is optional; a same-shop image read happens only when the menu is opened.
      if(active&&!cached&&typeof shell!=='undefined'&&shell.active==='menu')
        resolveGenerationImage(active,card);
    });

    document.querySelectorAll('[data-bm-mobile-vehicle-search], .bm-mobile-nav__item--vehicle-search').forEach(item=>{
      item.hidden=Boolean(active);
    });
    return true;
  };

  const shell={
    active:'',
    menuToggle:null,
    menuOverlay:null,
    searchToggle:null,
    searchOverlay:null,
    headerObserver:null,
    cartObserver:null
  };
  let mobileLevel=null;
  const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
  let levelVersion=0,levelAnimation=null,rootScroll=0;
  let shellVersion=0,shellAnimations=[],shellClosing=false;
  const cancelShellMotion=()=>{shellAnimations.forEach(animation=>animation.cancel());shellAnimations=[]};

  const setMobileLevel=(item=null)=>{
    const overlay=shell.menuOverlay;
    if(!overlay)return;
    const previous=mobileLevel;
    const version=++levelVersion;
    levelAnimation?.cancel();
    const nav=overlay.querySelector('.bm-mobile-nav');
    const scroller=overlay.querySelector('.bm-mobile-menu-inner');
    nav?.removeAttribute('inert');
    const commit=()=>{
      mobileLevel=item;
      overlay.querySelectorAll('.bm-mobile-nav__list>.bm-mobile-nav__item').forEach(root=>{
      root.hidden=Boolean(item&&root!==item);
      root.classList.toggle('is-drilled',root===item);
      root.classList.toggle('is-expanded',root===item);
      const submenu=root.querySelector(':scope>.bm-mobile-nav__sublist');
      if(submenu)submenu.hidden=root!==item;
      root.querySelector('[data-bm-mobile-drill]')?.setAttribute('aria-expanded',String(root===item));
      });
    overlay.querySelector('[data-bm-mobile-nav-back]').hidden=!item;
    overlay.querySelector('[data-bm-mobile-nav-title]').textContent=item?.querySelector('.bm-mobile-nav__link-label')?.textContent.trim()||'Menu';
    if(item)overlay.querySelector('[data-bm-mobile-nav-back]').focus({preventScroll:true});
    else previous?.querySelector('[data-bm-mobile-drill]')?.focus({preventScroll:true});
      if(scroller)scroller.scrollTop=item?0:rootScroll;
    };
    if(!nav?.animate||reducedMotion.matches||item===previous){commit();return}
    if(item&&scroller)rootScroll=scroller.scrollTop;
    const direction=item?1:-1;
    nav.setAttribute('inert','');
    levelAnimation=nav.animate([{opacity:1,transform:'translateX(0)'},{opacity:0,transform:`translateX(${-direction*10}px)`}],
      {duration:80,easing:'ease-in',fill:'both'});
    levelAnimation.finished.then(()=>{
      if(version!==levelVersion||shell.active!=='menu')return;
      levelAnimation.cancel();nav.removeAttribute('inert');commit();
      levelAnimation=nav.animate([{opacity:0,transform:`translateX(${direction*12}px)`},{opacity:1,transform:'translateX(0)'}],
        {duration:130,easing:'cubic-bezier(.22,.75,.22,1)',fill:'both'});
      return levelAnimation.finished.then(()=>{if(version===levelVersion)levelAnimation.cancel()});
    }).catch(()=>{});
  };

  const activeOverlay=()=>shell.active==='menu'?shell.menuOverlay:shell.active==='search'?shell.searchOverlay:null;

  const resolveCurrentOverlay=(selector)=>{
    const candidates=[...document.querySelectorAll(selector)];
    if(!candidates.length)return null;
    const fresh=candidates.find(node=>node.closest('#header'))||candidates[0];
    candidates.forEach(node=>{
      if(node!==fresh&&node.dataset.bmPortaled==='true')node.remove();
    });
    return fresh;
  };

  const removePortaledShells=()=>{
    document.querySelectorAll('body > [data-bm-portaled="true"]').forEach(node=>node.remove());
    shell.menuOverlay=null;
    shell.searchOverlay=null;
  };

  const syncShellMetrics=()=>{
    const header=document.querySelector('#header');
    if(!header)return;
    const rect=header.getBoundingClientRect();
    const viewport=window.visualViewport;
    const viewportTop=viewport?.offsetTop||0;
    const viewportHeight=viewport?.height||window.innerHeight;
    const viewportBottom=viewportTop+viewportHeight;
    const headerBottom=Math.max(viewportTop,Math.min(viewportBottom,rect.bottom));
    const available=Math.max(0,viewportBottom-headerBottom);
    document.documentElement.style.setProperty('--bm-mobile-shell-top',`${Math.round(headerBottom)}px`);
    document.documentElement.style.setProperty('--bm-mobile-shell-height',`${Math.round(available)}px`);
  };

  const setShellState=(kind='')=>{
    const isMenu=kind==='menu';
    const isSearch=kind==='search';
    shell.active=kind;

    shell.menuToggle?.setAttribute('aria-expanded',String(isMenu));
    shell.searchToggle?.setAttribute('aria-expanded',String(isSearch));

    if(shell.menuOverlay){
      shell.menuOverlay.hidden=!isMenu;
      shell.menuOverlay.setAttribute('aria-hidden',String(!isMenu));
    }
    if(shell.searchOverlay){
      shell.searchOverlay.hidden=!isSearch;
      shell.searchOverlay.setAttribute('aria-hidden',String(!isSearch));
    }

    document.documentElement.classList.toggle('bm-mobile-shell-open',Boolean(kind));
    document.body.classList.toggle('bm-shell-menu-open',isMenu);
    document.body.classList.toggle('bm-shell-search-open',isSearch);
    if(kind)syncShellMetrics();
  };

  const closeShell=(restoreFocus=false)=>{
    const toggle=shell.active==='menu'?shell.menuToggle:shell.active==='search'?shell.searchToggle:null;
    const overlay=activeOverlay();
    const panel=overlay?.querySelector('.bm-mobile-menu-panel');
    const version=++shellVersion;
    cancelShellMotion();levelVersion++;levelAnimation?.cancel();
    overlay?.querySelector('.bm-mobile-nav')?.removeAttribute('inert');
    const finish=()=>{
      if(version!==shellVersion)return;
      shellClosing=false;
      cancelShellMotion();overlay?.removeAttribute('inert');setShellState('');
      if(restoreFocus&&toggle)toggle.focus({preventScroll:true});
    };
    toggle?.setAttribute('aria-expanded','false');
    if(!restoreFocus||!panel?.animate||reducedMotion.matches){finish();return}
    shellClosing=true;
    overlay.setAttribute('inert','');
    shellAnimations=[panel.animate([{opacity:1,transform:'translateY(0)'},{opacity:.6,transform:'translateY(14px)'}],
      {duration:180,easing:'ease-in',fill:'both'}),overlay.animate([{opacity:1},{opacity:0}],{duration:180,easing:'ease-in',fill:'both'})];
    shellAnimations[0].finished.then(finish).catch(()=>{});
  };
  reducedMotion.addEventListener?.('change',()=>{
    if(!reducedMotion.matches)return;
    levelVersion++;levelAnimation?.cancel();
    shell.menuOverlay?.querySelector('.bm-mobile-nav')?.removeAttribute('inert');
    if(shell.active)closeShell(true);
  });

  const miniCartIsOpen=()=>document.body.classList.contains('header-mini-cart-open');
  const closeMiniCart=()=>{
    if(!miniCartIsOpen())return false;
    const closeButton=document.querySelector('#HeaderMiniCart .bm-mini-cart__close');
    if(!closeButton)return false;
    closeButton.click();
    return true;
  };

  const focusables=(root)=>{
    if(!root)return [];
    const selector='a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
    return [...root.querySelectorAll(selector)].filter(el=>!el.hidden&&el.getAttribute('aria-hidden')!=='true'&&el.getClientRects().length>0);
  };

  const focusFirstInShell=()=>{
    const overlay=activeOverlay();
    if(!overlay)return;
    const preferred=shell.active==='search'
      ? overlay.querySelector('.bm-shell-search-input')
      : mobileLevel?overlay.querySelector('[data-bm-mobile-nav-back]'):overlay.querySelector('[data-bm-mobile-vehicle-action], .bm-mobile-nav__link, .bm-mobile-nav__expand');
    const target=preferred||focusables(overlay)[0];
    target?.focus?.({preventScroll:true});
  };

  const openShell=(kind)=>{
    if(kind===shell.active&&!shellClosing){closeShell(true);return}
    closeMiniCart();
    shellVersion++;shellClosing=false;cancelShellMotion();
    setShellState(kind);
    if(kind==='menu')syncMobileVehicleUI();
    const overlay=activeOverlay();overlay?.removeAttribute('inert');
    const panel=kind==='menu'?overlay?.querySelector('.bm-mobile-menu-panel'):null;
    if(panel?.animate&&!reducedMotion.matches){
      shellAnimations=[panel.animate([{opacity:.65,transform:'translateY(16px)'},{opacity:1,transform:'translateY(0)'}],
        {duration:220,easing:'cubic-bezier(.22,.75,.22,1)'}),overlay.animate([{opacity:0},{opacity:1}],{duration:160,easing:'ease-out'})];
    }
    window.requestAnimationFrame(()=>{
      focusFirstInShell();
      if(kind==='search')window.setTimeout(focusFirstInShell,40);
    });
  };

  const portalMobileShell=()=>{
    shell.menuToggle=document.querySelector('#header [data-bm-mobile-menu-toggle]');
    shell.searchToggle=document.querySelector('#header [data-bm-mobile-search-toggle]');
    shell.menuOverlay=resolveCurrentOverlay('[data-bm-mobile-menu-overlay]');
    shell.searchOverlay=resolveCurrentOverlay('[data-bm-mobile-search-overlay]');

    [shell.menuOverlay,shell.searchOverlay].forEach(overlay=>{
      if(!overlay)return;
      if(overlay.parentElement!==document.body)document.body.appendChild(overlay);
      overlay.dataset.bmPortaled='true';
    });

    syncShellMetrics();
    syncMobileVehicleUI();

    if('ResizeObserver'in window){
      shell.headerObserver?.disconnect?.();
      const header=document.querySelector('#header');
      if(header){
        shell.headerObserver=new ResizeObserver(syncShellMetrics);
        shell.headerObserver.observe(header);
      }
    }
  };

  const observeMiniCart=()=>{
    if(!('MutationObserver'in window)||!document.body)return;
    shell.cartObserver?.disconnect?.();
    shell.cartObserver=new MutationObserver(()=>{
      if(miniCartIsOpen()&&shell.active)closeShell(false);
    });
    shell.cartObserver.observe(document.body,{attributes:true,attributeFilter:['class']});
  };

  const toggleMobileSubmenu=(button)=>{
    const item=button.closest('.bm-mobile-nav__item');
    if(!item)return;
    const expanded=button.getAttribute('aria-expanded')==='true';
    const next=!expanded;
    button.setAttribute('aria-expanded',String(next));
    item.classList.toggle('is-expanded',next);
    const hiddenText=button.querySelector('.visually-hidden');
    if(hiddenText){
      const label=next
        ? button.dataset.collapseText||hiddenText.textContent
        : button.dataset.expandText||hiddenText.textContent;
      hiddenText.textContent=label.replace(/&amp;/g,'&');
    }
  };

  const trapFocus=(event)=>{
    if(event.key!=='Tab'||!shell.active)return;
    const overlay=activeOverlay();
    if(!overlay)return;
    const items=focusables(overlay);
    if(!items.length){event.preventDefault();return}
    const first=items[0];
    const last=items[items.length-1];
    const current=document.activeElement;
    if(event.shiftKey){
      if(current===first||!overlay.contains(current)){
        event.preventDefault();
        last.focus({preventScroll:true});
      }
    }else if(current===last||!overlay.contains(current)){
      event.preventDefault();
      first.focus({preventScroll:true});
    }
  };

  const bind=()=>{
    portalMobileShell();
    observeMiniCart();

    document.addEventListener('click',event=>{
      const cartToggle=event.target.closest?.('#mini-cart-toggle');
      if(cartToggle){if(shell.active)closeShell(false);return}

      const account=event.target.closest?.('.head-slot-nav-link-account');
      if(account&&shell.active){closeShell(false);return}

      const menuToggle=event.target.closest?.('[data-bm-mobile-menu-toggle]');
      if(menuToggle){event.preventDefault();openShell('menu');return}

      const searchToggle=event.target.closest?.('[data-bm-mobile-search-toggle]');
      if(searchToggle){event.preventDefault();openShell('search');return}

      const drill=event.target.closest?.('[data-bm-mobile-drill]');
      if(drill){event.preventDefault();setMobileLevel(drill.closest('.bm-mobile-nav__item'));return}
      if(event.target.closest?.('[data-bm-mobile-nav-back]')){event.preventDefault();setMobileLevel();return}

      const expandButton=event.target.closest?.('.bm-mobile-menu-overlay .bm-mobile-nav__expand');
      if(expandButton){
        event.preventDefault();
        event.stopPropagation();
        toggleMobileSubmenu(expandButton);
        return;
      }

      if(event.target.closest?.('[data-bm-mobile-overlay-close]')){
        event.preventDefault();
        closeShell(true);
        return;
      }

      if(shell.active==='menu'&&event.target.closest?.('.bm-mobile-menu-overlay a'))closeShell(false);
    },true);

    document.addEventListener('keydown',event=>{
      if(event.key==='Escape'&&shell.active){
        event.preventDefault();
        closeShell(true);
        return;
      }
      trapFocus(event);
    });

    const refreshMetrics=()=>{if(shell.active)syncShellMetrics()};
    window.addEventListener('resize',refreshMetrics,{passive:true});
    window.addEventListener('scroll',refreshMetrics,{passive:true});
    window.visualViewport?.addEventListener('resize',refreshMetrics,{passive:true});
    window.visualViewport?.addEventListener('scroll',refreshMetrics,{passive:true});

    window.addEventListener('pageshow',event=>{
      if(event.persisted)closeShell(false);
      portalMobileShell();
      observeMiniCart();
    });

    document.addEventListener('shopify:section:unload',event=>{
      if(event.target?.querySelector?.('#header')){
        closeShell(false);
        removePortaledShells();
      }
    });

    document.addEventListener('shopify:section:load',()=>{
      closeShell(false);
      window.requestAnimationFrame(()=>{
        portalMobileShell();
        observeMiniCart();
      });
    });

    mqDesktop.addEventListener?.('change',()=>{if(mqDesktop.matches)closeShell(false)});
  };

  const syncSoon=()=>window.requestAnimationFrame(syncMobileVehicleUI);
  window.addEventListener('bm:vehicle:change',syncSoon);
  document.addEventListener('bm:vehicle:ready',syncSoon);

  const start=()=>{
    bind();
    if(!syncMobileVehicleUI()){
      const observer=new MutationObserver(()=>{
        if(syncMobileVehicleUI())observer.disconnect();
      });
      observer.observe(document.documentElement,{childList:true,subtree:true});
      window.setTimeout(()=>observer.disconnect(),5000);
    }
    window.setTimeout(syncMobileVehicleUI,250);
    window.setTimeout(syncMobileVehicleUI,1000);
  };

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
